import '../constants/login.js';
import '../constants/activity.js';
import { isNode } from '../constants/common.js';

function getQueryString(name) {
    if (isNode) {
        // 如果在服务器端执行，则使用 Node.js 的 URL 模块解析 URL
        return '/';
    }
    else {
        // 如果在浏览器端执行，则使用 URLSearchParams API 解析 URL
        const queryParams = new URLSearchParams(window.location.search);
        return queryParams.get(name);
    }
}
function setCookie({ name, value, day = 1, path = '/', domain, }) {
    if (isNode)
        return;
    let str = name + '=' + value + '; ';
    if (day)
        str += 'expires=' + new Date(Date.now() + day * 24 * 3600 * 1000).toUTCString() + '; ';
    if (path)
        str += 'path=' + path + '; ';
    if (domain)
        str += 'domain=' + domain;
    document.cookie = str;
}
const formatPhone = (code, phone) => `+${code}${phone}`;

export { formatPhone, getQueryString, setCookie };
